import useObjectsView from "@organisms/ObjectsView/ObjectsView.context"
import ViewBar from "@organisms/ViewBar/ViewBar"

export default function ObjectsViewSearchInput() {
    const { searchKeywords, setSearchKeywords } = useObjectsView()

    return <ViewBar.SearchButton defaultValue={searchKeywords} onValueChange={setSearchKeywords} />
}
